var _defs, _circle, _circle2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestauranticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #80d261;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 212.1724278027,
    y1: 75.714320709,
    x2: 335.3921566521,
    y2: 411.256710856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80d261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 213.0157381318,
    y1: 137.3669621516,
    x2: 255.5771803345,
    y2: 253.2669740909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 279.0390093036,
    y1: 145.5684690135,
    x2: 319.2041485501,
    y2: 254.9430549599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 256,
    cy: 199.5378050268,
    r: 132.1232817277
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 256,
    cy: 199.5378050268,
    r: 95.9269662974
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m256.0000305176,42.2343978882c-86.8762817383,0-157.3034057617,70.4271240234-157.3034057617,157.3034057617,0,73.1922607422,111.6520385742,220.5416870117,146.8248901367,265.1441040039,5.3452758789,6.7782592773,15.6117553711,6.7782592773,20.95703125,0,35.1727905273-44.6024169922,146.8248291016-191.9518432617,146.8248291016-265.1441040039,0-86.8762817383-70.4271240234-157.3034057617-157.3033447266-157.3034057617Zm0,277.3876342773c-66.3207397461,0-120.0842895508-53.7635498047-120.0842895508-120.0842285156,0-66.3207397461,53.7635498047-120.0842895508,120.0842895508-120.0842895508,66.3206787109,0,120.0842285156,53.7635498047,120.0842285156,120.0842895508,0,66.3206787109-53.7635498047,120.0842285156-120.0842285156,120.0842285156Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m244.442744421,146.4464510921l-.000000036,20.837190978c-.0000000055,3.192032215-2.5876533908,5.7796855959-5.7796856059,5.7796855959h-.0000115594c-3.1920322189,0-5.7796856059-2.5876533869-5.7796856059-5.7796856059v-20.8371909124c0-3.0912179586-2.5059272813-5.59714524-5.59714524-5.59714524h-.0000111943c-3.091217944,0-5.5971452143,2.5059272681-5.5971452169,5.5971452121l-.000000018,20.8371909452c-.0000000028,3.192032217-2.5876533889,5.7796856009-5.7796856059,5.7796856009h-.0000115694c-3.1920322131,0-5.7796855976-2.5876533778-5.7796856059-5.7796855909l-.0000000539-20.8371910108c-.000000008-3.0912179149-2.5059272561-5.5971451565-5.597145171-5.5971451565h-.0000111943c-3.0912179294,0-5.5971451886,2.5059272549-5.597145194,5.5971451843l-.000000046,26.6168765739v16.7001993961c0,9.475282391,7.6812340342,17.1565164417,17.1565164417,17.1565164417h.0000171565v44.807622336c0,6.1824359172,5.0118545627,11.1942904799,11.1942904799,11.1942904799h.0000223886c6.1824359316,0,11.1942905051-5.011854576,11.1942905021-11.1942905076l-.0000000222-44.8076223083h.0000171565c9.4752824075,0,17.1565164417-7.6812340507,17.1565164417-17.1565164417v-16.7001993961l-.0000000689-26.6168766016c-.000000008-3.0912179149-2.5059272561-5.5971451565-5.597145171-5.5971451565h-.0000111943c-3.0912179294,0-5.5971451886,2.5059272549-5.597145194,5.5971451843Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m321.4124505826,174.858100907c0-18.7825450892-11.6115372021-34.0087949992-25.9351053355-34.0087949992s-25.9351053355,15.2262499101-25.9351053355,34.0087949992c0,13.5253091131,6.0217881961,25.2051139732,14.7408036613,30.6845756951v46.1849780433c0,6.1824648691,5.0118368051,11.1943016742,11.1943016742,11.1943016742s11.1943016742-5.0118368051,11.1943016742-11.1943016742v-46.1850349805c8.7191293395-5.4795186591,14.7408036613-17.1592096449,14.7408036613-30.6845187579Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestauranticon);
export default __webpack_public_path__ + "static/media/Restaurant icon.2d02d2d598879c82d4af2c45acad802a.svg";
export { ForwardRef as ReactComponent };